/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'safeEducation': {
    width: 16,
    height: 16,
    viewBox: '0 0 40 40',
    data: '<defs/><path pid="0" class="cls-1" d="M38.2.34H3A3.33 3.33 0 0 0-.38 3.62v34.67a2.05 2.05 0 0 0 2.05 2.05h37.11a.84.84 0 0 0 .84-.84V1.72A1.4 1.4 0 0 0 38.2.34zm-30 3.21h9.24v9.85a.22.22 0 0 1-.16.22.25.25 0 0 1-.27 0l-4.15-4.17-4.2 4.12a.25.25 0 0 1-.27 0 .21.21 0 0 1-.15-.22zM2.92 32.73V3.55h4.33v9.85A1.22 1.22 0 0 0 8 14.52a1.26 1.26 0 0 0 1.35-.27l3.5-3.43 3.49 3.43a1.28 1.28 0 0 0 .88.36 1.27 1.27 0 0 0 .47-.09 1.21 1.21 0 0 0 .77-1.12V3.55h17.87v29.18z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/safeEducation.js